import React from "react";
import { components, OptionProps } from "react-select";

import { MutedText } from "shared/styles";
import { StyledValue } from "../styles";

export const CountryOption: React.FC<OptionProps<any, false>> = ({ children, ...props }) => (
  <components.Option {...props}>
    <StyledValue>
      {props.data.iconComponent}
      {props.data.prefix && <MutedText>{props.data.prefix}</MutedText>}
      <span>{children}</span>
    </StyledValue>
  </components.Option>
);
